import React from 'react'
import { FaAngleRight } from 'react-icons/fa6'
import { Link } from 'react-router-dom'

function WWD() {

  return (
    <div className='about_sub' >
        <div className='about_sub_header'>
            <div className='about_sub_header_line'></div>
            <h2>ABOUT US</h2>
        </div>

        <div className='wwd_header'>
            <p>
                At The Lord Nations Foundation, we are a nonprofit organization committed to uplifting the lives of the less privileged by providing essential resources, education, and support for a better future.
            </p>
        </div>

        <div className='wwd_container' >
            <div className='wwd_container_box' >
                <div className='wwd_container_img'></div>
                <h3>OUR MISSION</h3>
                <p>
                    Our mission is to eradicate hunger, empower underprivileged individuals by providing access to education, healthcare, food, and opportunities for sustainable growth.
                </p>

                <Link className='wwd_container_link' >
                    <p>READ MORE</p>
                    <FaAngleRight/>
                </Link>
            </div>

            <div className='wwd_container_box' >
                <div className='wwd_container_img2'></div>
                <h3>OUR VISION</h3>
                <p>
                     We envision a world where every individual, regardless of background, has the opportunity to live with dignity, security, and hope.
                </p>

                <Link className='wwd_container_link' >
                    <p>READ MORE</p>
                    <FaAngleRight/>
                </Link>
            </div>

            <div className='wwd_container_box' >
                <div className='wwd_container_img3'></div>
                <h3>HOW YOU CAN HELP</h3>
                <p>
                    You can make a difference by donating, volunteering, or partnering with us to change lives
                </p>

                <Link className='wwd_container_link' >
                    <p>READ MORE</p>
                    <FaAngleRight/>
                </Link>
            </div>
        </div>
    </div>
  )
}

export default WWD